import React from 'react';
// @ts-ignore
import styles from './PernamentMedicationItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { SelectValue } from '../../../../Components/Base/Select/Select';

export type PermanentMedicamentIPLP = {
	id: string;
	associatedDiagnosis: SelectValue;
	diagnosis: SelectValue;
	form: SelectValue;
	formType: string;
	instruction: string;
	manual: string;
	name: string;
	payment: SelectValue;
	quantity: number;
	requestNumber: string;
	routeOfAdministration: SelectValue;
};

interface Props {
	item: PermanentMedicamentIPLP;
}

const PermanentMedicationIPLPItem: React.FC<Props> = ({ item }) => {
	const {
		name,
		form,
		quantity,
		payment,
		manual,
		instruction,
		routeOfAdministration,
	} = item;

	return (
		<div className={styles.content}>
			<div className={styles.medicament}>
				<div className={styles.title}>{name}</div>
			</div>
			<div className={styles.moreInfo}>
				{form && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.form'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{form.label}</div>
					</div>
				)}
				{quantity && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.amount'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{quantity}</div>
					</div>
				)}
				{payment.value && typeof payment.value === 'string' && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.payment'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{payment.value}</div>
					</div>
				)}
				{routeOfAdministration && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.howToAdministrate'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{routeOfAdministration.label}</div>
					</div>
				)}
				{manual && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.dosage'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{manual}</div>
					</div>
				)}
				{instruction && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.preparationProcedure'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{instruction}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PermanentMedicationIPLPItem;
